/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Box, Button, Grid, Tab, Tabs, Typography } from '@mui/material';
import { RfidsAutoBulkContext } from '../contexts/RfidAutoBulkContext';
import Breadcrumbs from '../../../modules/navigation/components/Breadcrumbs';
import TabPanel from '../../../modules/shared/tabs/TabPanel';
import RfidsAutoBulkDetail from '../components/RfidAutoBulkDetail';
import URLTabs from '../../../modules/shared/tabs/URLTabs';

const RfidAutoBulkDetailPage: React.FunctionComponent = () => {
  const { setDetailPage, setActiveRfidAutoBulk, activeRfidAutoBulk, activeMachine } =
    React.useContext(RfidsAutoBulkContext);

  const tabNames = ['details'];
  const baseUrl = `/autobulk/machines/rfids/`;
  const { tabValue, handleTabChange } = URLTabs(tabNames, baseUrl);

  const handleBack = () => {
    setDetailPage(false);
    setActiveRfidAutoBulk(null);
  };

  const links = [
    {
      onClick: () => setDetailPage(false),
      text: `${activeMachine?.value}`,
    },
    {
      onClick: () => null,
      text: `${activeRfidAutoBulk?.rfid_name}`,
    },
  ];

  return (
    <>
      <Grid justifyContent="space-between" container spacing={3}>
        <Grid item>
          <Typography style={{ marginBottom: 10, color: '#333', opacity: 0.6, cursor: 'pointer' }} onClick={handleBack}>
            ← Return to Rfid List
          </Typography>
          <Breadcrumbs links={links} />
        </Grid>
      </Grid>
      <br />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="machine tabs">
          <Tab style={{ textTransform: 'capitalize' }} label="Details" />
        </Tabs>
      </Box>
      <br />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TabPanel value={tabValue} index={0}>
            <RfidsAutoBulkDetail />
          </TabPanel>
        </Grid>
      </Grid>
      <br />
    </>
  );
};

export default RfidAutoBulkDetailPage;
